<template>
  <textarea
    :value="modelValue"
    :style="style"
    :disabled="disabled"
    :placeholder="placeholder"
    :maxlength="wordLimit"
    :min="0"
    :precision="0"
    :step="1"
    @input="handleChange"
    @paste="handlePaste"
    class="textarea-input"
    inputmode="numeric"
    :rows="style.textAreaRows || 3" />
</template>

<script setup>
import { debounce } from 'lodash'
import Toast from '@/h5/components/toast'
import LGSdk from '@/packages/plugins/languageSDK/index'

const props = defineProps({
  modelValue: [Number, String],
  placeholder: String,
  wordLimit: Number,
  disabled: Boolean,
  style: {
    type: Object,
    default: () => {}
  }
})

const emits = defineEmits(['update:modelValue', 'change'])

const showToast = debounce(
  (customMessage) => {
    Toast && Toast({ message: customMessage, duration: 1500 })
  },
  500,
  { leading: true, trailing: false }
)

const handlePaste = (e) => {
  e.preventDefault() // 阻止默认粘贴
  const pastedText = (e.clipboardData || window.clipboardData).getData('text')
  const filteredText = replaceValue(pastedText)

  document.execCommand('insertText', false, filteredText)
  handleChange(e)
}

const handleChange = (e) => {
  let value = e.target.value
  const newValue = replaceValue(value)
  setTimeout(() => {
    e.target.value = newValue // 直接修改DOM值
    emits('update:modelValue', newValue)
    emits('change', newValue)
  })

  if (props.wordLimit <= value.length) {
    showToast(LGSdk.t('survey.maxInput'))
  }
}

const replaceValue = (value) => {
  if (value?.length > 0) {
    value = value.replace(/[^\d]/g, '') // 移除非数字和小数点以外的字符
    if (!value?.length) {
      value = null
    }
  }
  return value
}
</script>

<style scoped>
.textarea-input {
  width: 40%;
  resize: vertical;
  min-height: 5.7143rem;
}
</style>
